import { useEffect } from "react";

/** D (2026-02 Product Readiness Review): Esc closes modals — one shared hook so every
 * modal/dialog/palette in the app gets consistent Esc-to-close behaviour instead of each
 * component reimplementing its own keydown listener. Pass `active=false` to skip attaching
 * the listener when the modal/dialog isn't currently open. */
export function useEscapeKey(onClose, active = true) {
  useEffect(() => {
    if (!active) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active, onClose]);
}
